<div class="container-box inner-wrap">
  <h1 class="contact">Contact us</h1>
  <div class='row'>
    <div class='col-md-6 col-sm-12'>
      <div class="row">
      <div class='col-md-4 col-sm-4'>
        <i class="icon-misc-customersupportL icon-custm-style"></i>
      </div>
      <div class='col-md-7 col-sm-7'>
        <h2>By phone</h2>
        <p>Representatives are available <br> {{timeZone}} <br> Monday through Friday</p>
        <p>{{phone}}</p>
      </div>
    </div>
    </div>

    <div class='col-md-6 col-sm-12'>
      <div class="row">
      <div class='col-md-4 col-sm-4'>
        <i class="icon-bubble-messagingL icon-custm-style"></i>
      </div>
      <div class='col-md-7 col-sm-7'>
        <h2>By chat</h2>
        <p>Representatives are available <br> {{timeZone}} <br> Monday through Friday</p>

      </div>
      </div>
      <div class="row chat">
      <div class="col-md-4 hide-sm">&nbsp;</div>
      <div class="col-sm-12 col-md-7">
        <button class="btn btn-primary">Chat</button>
      </div>
      </div>
    </div>

  </div>
</div>
